"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Filters = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C15.1630854,3 17.7544954,5.44763337 17.9835428,8.55221297 L17.9969526,8.80093156 C19.7920371,9.83792539 21,11.7778953 21,14 C21,17.3137085 18.3137085,20 15,20 C13.9071548,20 12.8825506,19.7078258 12.0000394,19.1973296 C11.1182883,19.7075866 10.0932925,20 9,20 C5.6862915,20 3,17.3137085 3,14 C3,11.879224 4.10030762,10.0154387 5.76119933,8.94836747 L5.98599243,8.80093156 C5.98854774,8.79943471 5.99870266,8.71652851 6.01645721,8.55221297 C6.24550463,5.44763337 8.83691461,3 12,3 Z M6.07384825,9.94407619 C4.81831707,10.851963 4,12.3304174 4,14 C4,16.7614237 6.23857625,19 9,19 C9.74370187,19 10.4494804,18.8376308 11.08382,18.5464081 C9.92842084,17.5494176 9.15716087,16.1205651 9.02144063,14.5108348 L9.0035571,14.1993629 C7.47860202,13.3184189 6.37748766,11.7863979 6.08020243,9.98342039 C6.07715186,9.96491925 6.07503379,9.95180452 6.07384825,9.94407619 Z M12,4 C9.23857625,4 7,6.23857625 7,9 C7,11.7614237 9.23857625,14 12,14 C14.7614237,14 17,11.7614237 17,9 C17,6.23857625 14.7614237,4 12,4 Z" })));
};
Filters.displayName = 'Filters';
exports.default = Filters;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Filters.js.map